import styled from 'styled-components/native';

import Button from 'components/Button';

export default styled(Button).attrs(({ theme }) => ({
  primary: true,
  bold: false,
  labelColor: theme.marketplaceOrderDetails.actionText,
}))``;
